import React from 'react';
import { Box, TextField } from '@mui/material';
import { VideoBlockData } from '../../../../models/courses';

interface VideoBlockProps {
  data: VideoBlockData;
  onChange: (_data: VideoBlockData) => void;
  disabled?: boolean;
}

export const VideoBlock: React.FC<VideoBlockProps> = ({
  data,
  onChange,
  disabled,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <TextField
        label="Провайдер"
        size="small"
        fullWidth
        value={data.provider}
        onChange={(e) => onChange({ ...data, provider: e.target.value })}
        disabled={disabled}
        placeholder="youtube"
      />
      <TextField
        label="ID видео"
        size="small"
        fullWidth
        value={data.video_id}
        onChange={(e) => onChange({ ...data, video_id: e.target.value })}
        disabled={disabled}
        placeholder="dQw4w9WgXcQ"
      />
      <TextField
        label="Подпись"
        size="small"
        fullWidth
        value={data.caption}
        onChange={(e) => onChange({ ...data, caption: e.target.value })}
        disabled={disabled}
      />
    </Box>
  );
};
